import { PERMISSIONS } from '@/helpers/auth/permissions';

export const combinedKnowledgePermissions = [
    PERMISSIONS.APPEX_LESSON,
    PERMISSIONS.APPEX_PM_LESSON,
    PERMISSIONS.APPEX_X_LESSON,
    PERMISSIONS.APPEX_TRADE,
    PERMISSIONS.APPEX_PM_PHASE,
    PERMISSIONS.APPEX_PM_SUB_PHASE,
    PERMISSIONS.APPEX_X_PROCESS,
    PERMISSIONS.APPEX_X_SUB_PROCESS,
];

export const approvePermissions = [
    PERMISSIONS.APPEX_LESSON_APPROVE,
    PERMISSIONS.APPEX_PM_LESSON_APPROVE,
    PERMISSIONS.APPEX_X_LESSON_APPROVE,
];

export const transferExperiencePermissions = [
    PERMISSIONS.APPEX_LESSON_CREATE,
    PERMISSIONS.APPEX_PM_LESSON_CREATE,
    PERMISSIONS.APPEX_X_LESSON_CREATE,
];

export const groupedPMLessonPermissions = [PERMISSIONS.APPEX_PM_LESSON, PERMISSIONS.APPEX_PM_SUB_PHASE];

export const groupedXLessonPermissions = [PERMISSIONS.APPEX_X_LESSON, PERMISSIONS.APPEX_X_SUB_PROCESS];

export const printMultipleWorksheetsPermissions = [PERMISSIONS.APPEX_PROJECT, PERMISSIONS.APPEX_PROJECT_PRINT];
